﻿//JDP - Set classes
const headerElement = document.getElementById('header-job-detail');
const headerApplicationElement = document.getElementById('job-sticky-bar');

let lastScrollTop = 0;

// JDP - Body class
// Add class job-detail to body if header element exists
if (headerElement) {
	// The element exists
	document.body.classList.add('job-detail');
}

// JDP - Move up navigation if scolled 100 pixels from top
window.addEventListener('scroll', () => {
	let scrollPosition = window.scrollY;
	if (scrollPosition > 100) {
		headerElement.classList.add('navigation-hide-menu');
		let st = document.documentElement.scrollTop;
		if (st > lastScrollTop){
			// user is scrolling down
		} else {
			// user is scrolling up
			headerElement.classList.remove('navigation-hide-menu');
		}
		lastScrollTop = st <= 0 ? 0 : st;
	}
});

// JDP - Job application bar - show/hide
const jobApplicationHeaderTrigger = document.getElementsByClassName('info-action')[0];
const body = document.body;

const checkScrollPosition = () => {
	if (jobApplicationHeaderTrigger.getBoundingClientRect().bottom > 100) {
		headerApplicationElement.classList.remove('show');
	} else {
		headerApplicationElement.classList.add('show');
	}
};

window.addEventListener('scroll', () => {
	checkScrollPosition();
});

// JDP - Slider
document.addEventListener("DOMContentLoaded", function() {
	const sliders = document.querySelectorAll('.slider--version-01');

	sliders.forEach(function(slider, index) {
		const y = slider.getElementsByClassName("swiper");
		slider.classList.add('slider--' + index);

		var swiper = new Swiper(y[0], {
			spaceBetween: 20,
			grabCursor: true,
			navigation: {
				nextEl: '.slider--' + index + ' .swiper-button-next',
				prevEl: '.slider--' + index + ' .swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			on: {
				lock: function () {
					slider.classList.remove("is-active");
				},
				unlock: function () {
					slider.classList.add("is-active");
				},
			},
		});
	});

	const sliders2 = document.querySelectorAll('.slider--version-02');

	sliders2.forEach(function(slider, index) {
		const y = slider.getElementsByClassName("swiper");
		slider.classList.add('slider--' + index);

		var swiper = new Swiper(y[0], {
			spaceBetween: 20,
			grabCursor: true,
			navigation: {
				nextEl: '.slider--' + index + ' .swiper-button-next',
				prevEl: '.slider--' + index + ' .swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
			on: {
				lock: function () {
					slider.classList.remove("is-active");
				},
				unlock: function () {
					slider.classList.add("is-active");
				},
			},
		});
	});
});
